import { render, staticRenderFns } from "./time-progress-component.vue?vue&type=template&id=afb07588&"
import script from "./time-progress-component.vue?vue&type=script&lang=js&"
export * from "./time-progress-component.vue?vue&type=script&lang=js&"
import style0 from "./time-progress-component.vue?vue&type=style&index=0&id=afb07588&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports